import {
  Box,
  Container,
  Flex,
  Heading,
  Spacer,
  Stack,
  Text,
} from '@chakra-ui/react';
import { PropsWithChildren, ReactElement, ReactNode } from 'react';

export interface PageHeaderProps {
  title: ReactNode;
  subTitle?: ReactNode;
  icon?: ReactNode;
  topRightSection?: ReactElement;
  // renderEditButton?: React.ComponentType<Partial<ButtonProps>>;
}

export const PageHeader = (props: PropsWithChildren<PageHeaderProps>) => {
  const {
    title,
    subTitle,
    children,
    // renderEditButton: EditButton,
    topRightSection,
  } = props;

  return (
    <Box
      as="section"
      bg="bg-surface"
      pt={{ base: '4', md: '8' }}
      pb={{ base: '4', md: '8' }}
      borderRadius={'lg'}
      boxShadow={'2xl'}
    >
      <Container minW={'100%'}>
        <Stack
          spacing="4"
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
        >
          <Stack spacing="1" w="100%">
            <Flex>
              <Heading size={{ base: 'xs', md: 'sm' }} fontWeight="medium">
                <Text noOfLines={1}>{title}</Text>
              </Heading>
              <Spacer />
              {topRightSection}
            </Flex>

            <Text color="muted" noOfLines={1}>
              {subTitle}
            </Text>
          </Stack>
          {/* Search Feature */}
          {/* <InputGroup maxW={{ sm: 'xs' }}>
            <InputLeftElement pointerEvents="none">
              <Icon as={FiSearch} color="muted" boxSize="5" />
            </InputLeftElement>
            <Input placeholder="Search" />
          </InputGroup> */}
        </Stack>
        {children && (
          <Stack pt="4">
            <Box>{children}</Box>
          </Stack>
        )}
        {/* <Stack>{children && <Box>{children}</Box>}</Stack> */}
      </Container>
    </Box>
  );
};
